// src/pages/gears/Neo.js

import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import AffiliateAmazon from "../../components/affiliate/AffiliateAmazon";
import AffiliateEbay from "../../components/affiliate/AffiliateEbay";
import React, { useState } from "react";

// ⭐ IMPORT ONLY THE IMAGES YOU NEED
import droneImg from "./gearimages/drone.jpg";

export default function Neo() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "10px" }}>
        <section className="gear-review">

          {/* ⭐ NEW GEAR LAYOUT */}
          <div className="gear-container">

            {/* LEFT COLUMN */}
            <div className="gear-left">
              <h1>DJI Neo</h1>

              <p>
                The DJI Neo is a compact, beginner-friendly drone that punches above its
                weight in both performance and creativity. With a 12MP camera capable of
                shooting crisp 4K video at 30fps, it’s perfect for travel storytelling,
                gear reviews, and capturing immersive aerial footage.
              </p>

              <p>
                Its AI subject tracking and QuickShot modes make every flight feel cinematic.
                The Neo is also compatible with DJI’s FPV-style headset and RC‑N3 remote,
                extending your flight range up to 7 km and giving you a more immersive
                experience.
              </p>

              <div className="place-block">
                <ul>
                  <li>12MP camera with 4K video at 30fps</li>
                  <li>RockSteady + HorizonBalancing stabilization</li>
                  <li>Up to 18 minutes of flight time</li>
                  <li>Max flight distance: 7 km (with controller)</li>
                  <li>AI subject tracking + QuickShot modes</li>
                  <li>Palm takeoff/landing + gesture controls</li>
                  <li>Lightweight 135g ultra‑portable design</li>
                  <li>Optional FPV headset support</li>
                  <li>Operates via DJI Fly app or RC‑N3</li>
                </ul>

                <p>
                  Whether you're chasing sunrises, reviewing gear in motion, or capturing drone
                  footage for affiliate content, the Neo delivers smooth, vibrant visuals with
                  minimal setup.
                </p>
              </div>

              <AffiliateAmazon
                title="check price on Amazon"
                link="https://amzn.to/3JAdZvQ"
              />

              <AffiliateEbay
                title="Check price on eBay"
                link="https://www.ebay.com/sch/i.html?_nkw=DJI+Neo&_sacat=0&_from=R40&_trksid=p2334524.m570.l1313&_odkw=drone+dji+mavic+pro+2&_sop=12&mkcid=1&mkrid=711-53200-19255-0&siteid=0&campid=5339120542&customid=DJINeo&toolid=10001&mkevt=1"
              />
            </div>

            {/* RIGHT COLUMN */}
            <div className="gear-right">
              <img src={droneImg} alt="DJI Neo" />
            </div>

          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
